var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9961 28.4034V34.4034H43.9961V38.4034H37.9961V44.4034H33.9961V38.4034H27.9961V34.4034H33.9961V28.4034H37.9961ZM40.4821 9.91745C42.5456 11.9804 43.7867 14.7244 43.9733 17.6362C44.1599 20.548 43.2793 23.428 41.4961 25.7374C39.2273 24.5671 36.6444 24.1509 34.1228 24.5492C31.6012 24.9475 29.2724 26.1395 27.4747 27.9521C25.677 29.7647 24.5043 32.1034 24.1269 34.6282C23.7495 37.153 24.1871 39.7324 25.3761 41.9914L23.9961 43.3734L7.03814 26.3894C4.99665 24.1014 3.90854 21.1186 3.99721 18.0534C4.08588 14.9883 5.34459 12.0733 7.51493 9.9071C9.68527 7.74086 12.6026 6.48766 15.6679 6.40478C18.7332 6.3219 21.7139 7.41564 23.9981 9.46145C26.2833 7.41585 29.2651 6.32318 32.3309 6.40799C35.3967 6.4928 38.3136 7.74864 40.4821 9.91745Z",
    fill: "#FF0060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9961 28.4034H37.9961V34.4034H43.9961V38.4034H37.9961V44.4034H33.9961V38.4034H27.9961V34.4034H33.9961V28.4034Z",
    fill: "#0079FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.d3497d68175b7fa483872d4173fafb4b.svg";
export { ForwardRef as ReactComponent };